import { useQueryParams } from 'modules/common/hooks/useQueryParams';
import { createRouteConfig } from 'modules/router/utils/createRouteConfig';
import { UnsubscribeQueryParams } from 'modules/unsubscribe/types';

export const UNSUBSCRIBE_PATH = '/unsubscribe';

const generatePath = (params: UnsubscribeQueryParams) =>
  `${UNSUBSCRIBE_PATH}?${new URLSearchParams({
    ...params,
  }).toString()}`;

export const unsubscribeRoutesConfig = createRouteConfig(
  {
    unsubscribe: {
      path: UNSUBSCRIBE_PATH,
      breadcrumbs: 'unsubscribe.breadcrumbs',
      generatePath: (params: UnsubscribeQueryParams) => generatePath(params),
      useQuery: () => {
        const search = useQueryParams();
        const entries = search.entries();

        return Object.fromEntries(entries) as unknown as UnsubscribeQueryParams;
      },
    },
  },
  UNSUBSCRIBE_PATH,
);
